import { render, staticRenderFns } from "./Recordatorios.vue?vue&type=template&id=222f99ff&scoped=true&"
import script from "./Recordatorios.vue?vue&type=script&lang=js&"
export * from "./Recordatorios.vue?vue&type=script&lang=js&"
import style0 from "./Recordatorios.vue?vue&type=style&index=0&id=222f99ff&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "222f99ff",
  null
  
)

export default component.exports